import { sortPatients } from '../patientListUtils';

const byName = (a, b) => (a.name || '').localeCompare(b.name || '') || String(a.id).localeCompare(String(b.id));

// The charge nurse's board: one column per nurse on the unit, most patients
// first (including nurses with no patients right now, so patients can be
// dragged to them), each with their sheets in room order.
//
// A nurse's patients should always be on their own unit, so every sheet
// normally lands in one of those columns. If one is owned by someone who
// isn't on the unit's roster (bad data), it isn't hidden: it gets a column
// for that owner, flagged `notOnUnit` and listed after the unit's nurses, so
// the charge nurse can see it and reassign it.
//
// `nurses` is the unit's roster (GET /api/nurses). If it's unavailable
// (null), columns simply follow the sheets' owners.
export function groupByNurse(sheets, nurses, myEmail) {
  const mine = (myEmail || '').trim().toLowerCase();
  const columns = new Map();
  (nurses || []).filter((n) => n.id).forEach((n) => {
    columns.set(n.id, {
      id: n.id,
      name: n.name || n.email || 'Unknown nurse',
      isMine: Boolean(mine) && (n.email || '').trim().toLowerCase() === mine,
      notOnUnit: false,
      sheets: [],
    });
  });
  sortPatients(sheets || []).forEach((sheet) => {
    const id = sheet.owner?.id || `unknown:${sheet.owner?.name || ''}`;
    if (!columns.has(id)) {
      columns.set(id, {
        id,
        name: sheet.owner?.name || 'Unknown nurse',
        isMine: false,
        notOnUnit: Boolean(nurses),
        sheets: [],
      });
    }
    const column = columns.get(id);
    column.sheets.push(sheet);
    if (sheet.owner?.isMine) column.isMine = true;
  });
  // The busiest nurses first (ties A–Z), so nurses with no patients end up
  // last among the unit's nurses; nurses not on the unit come after them.
  const busiestFirst = (a, b) => b.sheets.length - a.sheets.length || byName(a, b);
  const all = [...columns.values()];
  return [...all.filter((c) => !c.notOnUnit).sort(busiestFirst), ...all.filter((c) => c.notOnUnit).sort(byName)];
}

// The sheets with one moved to another nurse, so the board can update before
// the backend answers (and move it back if the backend refuses).
export function moveSheet(sheets, reportId, nurse) {
  return sheets.map((s) => (s.reportId === reportId
    ? { ...s, owner: { ...s.owner, id: nurse.id, name: nurse.name, isMine: Boolean(nurse.isMine) } }
    : s));
}
